/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerDocumentErrorMetadataRelatedDocumentInformationInner } from './ScreenerDocumentErrorMetadataRelatedDocumentInformationInner';
import {
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON,
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped,
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON,
    ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSONTyped,
} from './ScreenerDocumentErrorMetadataRelatedDocumentInformationInner';

/**
 * 
 * @export
 * @interface ScreenerDocumentErrorMetadata
 */
export interface ScreenerDocumentErrorMetadata {
    /**
     * 
     */
    related_document_information?: Array<ScreenerDocumentErrorMetadataRelatedDocumentInformationInner>;
    /**
     * Reason for the error (used with PROCESSING_ERROR type)
     */
    reason?: string;
    /**
     * Human-readable error message (used with PROCESSING_ERROR type)
     */
    message?: string;
}

/**
 * Check if a given object implements the ScreenerDocumentErrorMetadata interface.
 */
export function instanceOfScreenerDocumentErrorMetadata(value: object): value is ScreenerDocumentErrorMetadata {
    return true;
}

export function ScreenerDocumentErrorMetadataFromJSON(json: any): ScreenerDocumentErrorMetadata {
    return ScreenerDocumentErrorMetadataFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentErrorMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'related_document_information': json['related_document_information'] == null ? undefined : ((json['related_document_information'] as Array<any>).map(ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON)),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ScreenerDocumentErrorMetadataToJSON(json: any): ScreenerDocumentErrorMetadata {
    return ScreenerDocumentErrorMetadataToJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataToJSONTyped(value?: ScreenerDocumentErrorMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'related_document_information': value['related_document_information'] == null ? undefined : ((value['related_document_information'] as Array<any>).map(ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON)),
        'reason': value['reason'],
        'message': value['message'],
    };
}

